import {PluginKey} from 'prosemirror-state';
import type {DecorationSet} from 'prosemirror-view';

export const widgetDecorationPluginKey = new PluginKey<DecorationSet>();
